import { ReactNode } from "react";
import { Tooltip } from "@sellar-io/components";
import { TooltipContent } from "@sellar-io/components";
import { TooltipTrigger } from "@sellar-io/components";

export const SignUpToOrderTooltip = ({
  enable = false,
  children,
}: {
  enable: boolean;
  children: ReactNode;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger className="w-full">{children}</TooltipTrigger>
      {enable && (
        <TooltipContent
          className={
            "Tooltip flex justify-center rounded-lg bg-zinc-800 px-2 py-1 text-sm text-white"
          }
        >
          Sign up to order
          <span className="absolute -bottom-1 block h-2 w-2 rotate-45 bg-zinc-800" />
        </TooltipContent>
      )}
    </Tooltip>
  );
};
